function validEmail(email) {
  const re =
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function customValidation(data) {
  let errorsValidation = {};
  let error = false;

  data.forEach((element) => {
    if (!element.condition) {
      errorsValidation[element.key] =
        element.helperText || "Campo obrigatório.";
      error = true;
    } else {
      errorsValidation[element.key] = false;
    }
  });

  return { error, errorsValidation };
}

function validNotNull(data) {
  let errorsValidation = {};
  let error = false;

  data.forEach((element) => {
    if (!element.value) {
      errorsValidation[element.key] = "Campo obrigatório";
      error = true;
    } else {
      errorsValidation[element.key] = false;
    }
  });

  return { error, errorsValidation };
}

function validTypeFile({ file, types }) {
  try {
    if (!file || !Array.isArray(types) || types.length < 1) {
      return false;
    }

    const valid = types.filter((e) => {
      if (file.name.toLowerCase().includes(e.toLowerCase())) {
        return e;
      } else {
        return false;
      }
    });

    if (!file.name.includes(valid[0])) {
      return false;
    }

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}

function isFloat(value) {
  return value % 1 !== 0;
}

function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, "");

  if (cpf.length !== 11) return false;

  // Elimina CPFs inválidos conhecidos
  if (/^(\d)\1+$/.test(cpf)) return false;

  // Valida 1º dígito
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(cpf.charAt(9))) return false;

  // Valida 2º dígito
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(cpf.charAt(10))) return false;

  return true;
}

function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs inválidos conhecidos
  if (/^(\d)\1+$/.test(cnpj)) return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(1))) return false;

  return true;
}

export {
  validEmail,
  customValidation,
  validNotNull,
  validTypeFile,
  isFloat,
  validarCPF,
  validarCNPJ,
};
